<form [formGroup]="DinamicForm" >
    <dnc-title [check]="check" [editable]="editable"></dnc-title>
    <textarea name="textarea"  class="form-control" [readonly]="(check?.target?.readonly || !editable)" [rows]="check.target.rows" (change)="dynamicEmit()" [cols]="check.target.cols" [placeholder]="check.target.placeholder" [formControlName]="check.formControlName"></textarea>   
    <small class="text-danger" *ngIf="fieldisValid.campoEsValido(this.check.formControlName, DinamicForm)">{{check.validateMessage}}</small>
</form>
